import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";

/**
 * UnbookedImsBanner — persistent inline banner shown when there are 2B
 * entries marked ACCEPT that have not yet been booked as vouchers in the
 * ERP. Polls /api/gst-compliance/unbooked-2b-count every 5 minutes.
 * Click routes the user to the IMS Dashboard.
 */
export default function UnbookedImsBanner() {
  const [count, setCount] = useState(0);
  const nav = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const r = await api.get("/gst-compliance/unbooked-2b-count");
        setCount(r.data?.unbooked_count || 0);
      } catch {
        /* silent */
      }
    };
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  if (count === 0) return null;
  return (
    <button
      onClick={() => nav("/app/ims")}
      className="w-full flex items-center gap-2 px-3 py-2 border-l-4 border-amber-500 bg-amber-50 hover:bg-amber-100 text-amber-900 text-xs font-medium rounded-sm"
      data-testid="unbooked-ims-banner"
    >
      <AlertCircle className="w-4 h-4 shrink-0" />
      <span className="flex-1 text-left">
        <b>{count}</b> unbooked GSTR-2B entr{count === 1 ? "y" : "ies"} — click to book them in your books before your next filing.
      </span>
    </button>
  );
}
